module.exports = __webpack_public_path__ + "img/icon-group-color.254841ad.png";